import React from 'react';
import { Tag, Tooltip } from 'antd';

/**
 * 「沿用护照」标签：老客户再次报团时系统自动沿用了历史有效护照（tourist.passportReuse）。
 * 悬停显示来源订单与护照信息；客人换了新护照、重新上传后标记自动消失。
 */
const PassportReuseTag = ({ reuse, style }) => {
  if (!reuse) return null;
  const r = typeof reuse === 'string' ? (() => { try { return JSON.parse(reuse); } catch { return null; } })() : reuse;
  if (!r) return null;
  const title = (
    <div style={{ lineHeight: 1.7 }}>
      <div>来源订单：{r.fromTourName || '-'}{r.fromDepartureDate ? `（${r.fromDepartureDate} 出团）` : ''}</div>
      <div>护照号码：{r.passportNumber || '-'}</div>
      <div>有效期至：{r.passportExpiryDate || '-'}</div>
      <div>无需重新上传；客人如已更换护照，请重新上传</div>
    </div>
  );
  return (
    <Tooltip title={title}>
      <Tag color="cyan" style={{ marginRight: 0, cursor: 'default', ...style }}>沿用护照</Tag>
    </Tooltip>
  );
};

export default PassportReuseTag;
